import { I18n } from '@front/volcanion'
import FormatUtils from '@front/squirtle/utils/format'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        client_id: record?.client_id,
        name: record?.name,
        central_priority_number: record?.central_priority_number,
        contact: {
          email: record?.contact?.email,
          address: record?.contact?.address,
          gsm: record?.contact?.gsm,
        },
        info: {
          nace: record?.info?.nace,
          language: record?.info?.language
        },
        exclude_heatmap: record?.exclude_heatmap,
        bypass_heatmap_cascade: record?.bypass_heatmap_cascade,
        bonus_heatmap: record?.bonus_heatmap,
        to_check_billing: record?.to_check_billing,
        booker_voucher_management_enabled: record?.booker_voucher_management_enabled,
        priority: record?.priority,
        status: FormatUtils.getStatus(_.pick(record, ['active', 'deleted', 'suspendedUntil', 'suspendedSince'])),
      }
    }
  }

  static formToRecordHandler() {
    return function formToRecord(values, extra, meta, { suspended }) {
      const current_status = _.find(meta, ['field', 'status'])?.initial
      return {
        client_id: values?.client_id,
        name: values?.name,
        central_priority_number: values?.central_priority_number,
        contact: {
          email: values?.contact?.email,
          address: values?.contact?.address,
          gsm: values?.contact?.gsm,
        },
        info: {
          nace: values?.info?.nace,
          language: values?.info?.language
        },
        exclude_heatmap: values?.exclude_heatmap,
        bypass_heatmap_cascade: values?.bypass_heatmap_cascade,
        bonus_heatmap: values?.bonus_heatmap,
        to_check_billing: values?.to_check_billing,
        booker_voucher_management_enabled: values?.booker_voucher_management_enabled,
        priority: values?.priority,
        status: FormatUtils.parseStatus(_.get(values, 'status', current_status), _.pick(suspended, ['suspendedUntil', 'suspendedSince', 'motive']))
      }
    }
  }

  static getEmptyFormHandler() {
    return function getEmptyFormValues() {
      return {
        status: 'active'
      }
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        tab: 1,
        title: record?.client_id,
        suspended: {
          suspendedUntil: record?.suspendedUntil,
          suspendedSince: record?.suspendedSince,
          motive: record?.motive
        }
      }
    }
  }

  static formToOptionsHandler() {
    return function formToOptions(values, extra, meta, state) {
      return { force_order_cancel: !!extra?.forceSubmit }
    }
  }

  static onSubmitSuccessHandler(requestlimitorder, requestSubmitCompanyTemplate) {
    return async function onSubmitSuccess(result, values, extra, meta) {
      requestlimitorder({ company: result?.company_id })
      !!requestSubmitCompanyTemplate && requestSubmitCompanyTemplate({ company: result?.company_id })
    }
  }

  static onSubmitFailedHandler(openDialog) {
    return async function onSubmitFailed(err, values, extra, meta) {
      if (err?.code === 'ACTIVE_JOBS')
        openDialog('show_active_jobs', {
          title: I18n.t('driver.popup.show_active_jobs.pending_orders.title'),
          description: I18n.t('driver.popup.show_active_jobs.pending_orders.description', { entity: I18n.t('driver.popup.show_active_jobs.entity.company') }),
          job_ids: err?.context?.job_ids,
        })
    }
  }

  static getFailedNotificationHandler() {
    return function getFailedNotification(err, data, extra, meta, state) {
      const code = err.getCode()
      const context = err.getContext()
      if (code === 'RECORD_EXISTS' && context?.key === 'client_id') {
        return [I18n.t('error.already_exists.company_client_id'), { variant: 'error' }]
      }
    }
  }
}

export default Callbacks
